import { Channel } from 'pusher-js';
import { Observable, Subject } from 'rxjs';
import { PushChannel } from '../../../push-notifications/src/models/push-channel';
import { PusherEvent, PusherEventImpl } from './pusher-event';

export class PusherChannel implements PushChannel {
  private readonly event = new Subject<PusherEventImpl>();

  constructor(private readonly channel: Channel) {}

  getEvent(name: string): Observable<PusherEventImpl> {
    this.channel.bind(name, (data: PusherEvent) =>
      this.event.next(new PusherEventImpl(data.name, data.data))
    );
    return this.event.asObservable();
  }
}
